document.querySelectorAll('.ht-standalone').forEach((root) => {
  const gallery = root.querySelector('[data-gallery]');
  const slides = [...root.querySelectorAll('[data-media-index]')];
  const thumbs = [...root.querySelectorAll('[data-media-target]')];
  const variants = JSON.parse(root.querySelector('[data-variants-json]')?.textContent || '[]');
  const variantSelect = root.querySelector('[data-variant-select]');
  const variantInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-price]');
  const compare = root.querySelector('[data-compare]');
  const sale = root.querySelector('[data-sale]');
  const sku = root.querySelector('[data-sku]');
  const atc = root.querySelector('[data-atc]');
  const atcLabel = root.querySelector('[data-atc-label]');
  const checkout = root.querySelector('[data-checkout]');
  const checkoutLabel = root.querySelector('[data-checkout-label]');
  const quantity = root.querySelector('input[name="quantity"]');
  const currency = root.dataset.currency || 'USD';
  const purchase = { purchasing: false, checkout: false, added: false };
  let currentMedia = 0;

  root.standalonePurchase = purchase;
  root.syncStandalonePurchase = () => {
    const variant = variants.find((item) => String(item.id) === String(variantInput.value));
    const available = Boolean(variant?.available);
    atc.disabled = purchase.purchasing || !available;
    checkout.disabled = purchase.purchasing || !available;
    atcLabel.textContent = available ? 'Add to Cart' : 'Sold out';
    checkoutLabel.textContent = purchase.purchasing && purchase.checkout ? 'Adding…' : 'Buy Now';
  };

  root.unsubscribeStandaloneCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
    if (purchase.purchasing && payload.source === 'product-form' && String(payload.productVariantId) === String(variantInput.value)) purchase.added = true;
  });

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency,
  }).format(Number(cents || 0) / 100);

  const setMedia = (index, behavior = 'smooth') => {
    if (!gallery || !slides.length) return;
    currentMedia = Math.max(0, Math.min(index, slides.length - 1));
    gallery.scrollTo({ left: slides[currentMedia].offsetLeft, behavior });
    thumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-pressed', String(thumbIndex === currentMedia)));
  };

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => setMedia(Number(thumb.dataset.mediaTarget))));
  root.querySelectorAll('[data-media-step]').forEach((button) => button.addEventListener('click', () => {
    setMedia((currentMedia + Number(button.dataset.mediaStep) + slides.length) % slides.length);
  }));
  gallery?.addEventListener('scrollend', () => {
    const closest = slides.reduce((best, slide, index) => (
      Math.abs(slide.offsetLeft - gallery.scrollLeft) < Math.abs(slides[best].offsetLeft - gallery.scrollLeft) ? index : best
    ), 0);
    currentMedia = closest;
    thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === closest)));
  });

  const renderVariant = (variant) => {
    if (!variant) return;
    variantInput.value = variant.id;
    price.textContent = money(variant.price);
    const onSale = Number(variant.compare_at_price) > Number(variant.price);
    compare.hidden = !onSale;
    sale.hidden = !onSale;
    if (onSale) compare.textContent = money(variant.compare_at_price);
    sku.hidden = !variant.sku;
    if (variant.sku) sku.querySelector('span').textContent = variant.sku;
    atc.disabled = !variant.available;
    atcLabel.textContent = variant.available ? 'Add to Cart' : 'Sold out';
    checkout.disabled = !variant.available;
    if (variant.featured_media?.id) {
      const mediaIndex = slides.findIndex((slide) => Number(slide.dataset.mediaId) === Number(variant.featured_media.id));
      if (mediaIndex >= 0) setMedia(mediaIndex);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  variantSelect?.addEventListener('change', () => {
    renderVariant(variants.find((variant) => String(variant.id) === variantSelect.value));
  });

  root.querySelectorAll('[data-quantity-delta]').forEach((button) => button.addEventListener('click', () => {
    const next = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityDelta));
    quantity.value = next;
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    purchase.purchasing = false;
    purchase.checkout = false;
    purchase.added = false;
    root.syncStandalonePurchase();
  });
});

customElements.whenDefined('product-form').then(() => {
  if (customElements.get('standalone-purchase-form')) return;
  class StandalonePurchaseForm extends customElements.get('product-form') {
    connectedCallback() {
      this.finishedObserver = new MutationObserver(() => {
        if (this.submitButton.classList.contains('loading')) return;
        const root = this.closest('.ht-standalone');
        const purchase = root?.standalonePurchase;
        if (!purchase?.purchasing) return;
        if (purchase.added && purchase.checkout) {
          location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
          return;
        }
        purchase.purchasing = false;
        purchase.checkout = false;
        root.syncStandalonePurchase();
      });
      this.finishedObserver.observe(this.submitButton, { attributes: true, attributeFilter: ['class'] });
    }

    disconnectedCallback() { this.finishedObserver?.disconnect(); }

    onSubmitHandler(event) {
      const root = this.closest('.ht-standalone');
      const purchase = root?.standalonePurchase;
      const variantInput = root?.querySelector('[data-variant-id]');
      const variants = JSON.parse(root?.querySelector('[data-variants-json]')?.textContent || '[]');
      const variant = variants.find((item) => String(item.id) === String(variantInput?.value));
      if (!root || !purchase || purchase.purchasing || !variant?.available || this.submitButton.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      purchase.checkout = Boolean(event.submitter?.hasAttribute('data-checkout'));
      purchase.added = false;
      purchase.purchasing = true;
      this.failure = '';
      root.syncStandalonePurchase();
      super.onSubmitHandler(event);
    }

    dispatchCartErrorEvent(message, code) {
      this.failure = message;
      this.handleErrorMessage(message);
      super.dispatchCartErrorEvent(message, code);
    }
  }
  customElements.define('standalone-purchase-form', StandalonePurchaseForm);
});
